module.exports = __webpack_public_path__ + "img/zztbg-4-en.9dac6885.png";